import { useLang } from "../i18n/LanguageContext";

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useLang();
  const base =
    "px-2.5 py-1 text-xs font-bold rounded-full transition-colors duration-200 uppercase tracking-wide";
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-1 rounded-full border border-gray-300 bg-white/70 p-0.5 ${className}`}
    >
      <button
        data-testid="lang-de"
        onClick={() => setLang("de")}
        className={`${base} ${lang === "de" ? "bg-[#1e2a6e] text-white" : "text-[#1e2a6e] hover:bg-gray-100"}`}
        aria-pressed={lang === "de"}
      >
        DE
      </button>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`${base} ${lang === "en" ? "bg-[#1e2a6e] text-white" : "text-[#1e2a6e] hover:bg-gray-100"}`}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
}
